import PropTypes from "prop-types";
import { Carousel } from "@asosteam/asos-web-component-library-carousel";
import CategoryPreviewHeader from "./CategoryPreviewHeader";
import renderProducts from "./renderProducts";
import useCarouselSettings from "../../../helpers/useCarouselSettings";
import { withTranslation } from "../../translation";
import { MediaContextProvider } from "@asosteam/asos-web-component-library-breakpoints";
import {
  VIEWPORT_TO_PAGE_SIZE,
  CAROUSEL_MODE_TO_COLUMN_WIDTH,
  CAROUSEL_ID,
  MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL,
} from "./constants";

const CategoryPreviewCarousel = ({
  categoryName,
  categoryUrl,
  formatNumber,
  formatTranslation,
  products,
  ...rest
}) => {
  const { carouselMode, pageSize } = useCarouselSettings();
  const columnWidth = CAROUSEL_MODE_TO_COLUMN_WIDTH[carouselMode];

  if (products?.length < MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL) return null;

  return (
    <>
      <CategoryPreviewHeader
        categoryName={categoryName}
        categoryUrl={categoryUrl}
      />
      <Carousel
        itemsPerRow={pageSize}
        carouselMode={carouselMode}
        columnWidth={columnWidth}
        paginationTabLabel={(lower, upper, total) =>
          formatTranslation("accessibility_plp_carousel_pagination_tab_label", {
            lowercount: formatNumber(lower),
            uppercount: formatNumber(upper),
            totalcount: formatNumber(total),
            smart_count: total,
          })
        }
        paginationTabPanelLabel={() => ""}
        paginationLabelNoPrevious={formatTranslation(
          "generic_carousel_pagination_no_previous",
        )}
        paginationLabelNoNext={formatTranslation(
          "generic_carousel_pagination_no_next",
        )}
        ariaDescribedby={CAROUSEL_ID}
      >
        {renderProducts({ products, categoryUrl, ...rest })}
      </Carousel>
    </>
  );
};

CategoryPreviewCarousel.propTypes = {
  categoryName: PropTypes.string.isRequired,
  categoryUrl: PropTypes.string.isRequired,
  formatNumber: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
};

const WrappedLoader = (props) => (
  <MediaContextProvider querySet={VIEWPORT_TO_PAGE_SIZE}>
    <CategoryPreviewCarousel {...props} />
  </MediaContextProvider>
);

export default withTranslation(WrappedLoader);
